import request from '@/utils/request'


// 查询用户转账记录列表
export function listUserTransferRecord(query) {
  return request({
    url: '/biz/admin/user/transfer/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户转账记录分页
export function pageUserTransferRecord(query) {
  return request({
    url: '/biz/admin/user/transfer/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户转账记录详细
export function getUserTransferRecord(data) {
  return request({
    url: '/biz/admin/user/transfer/detail',
    method: 'get',
    params: data
  })
}

// 新增用户转账记录
export function addUserTransferRecord(data) {
  return request({
    url: '/biz/admin/user/transfer/add',
    method: 'post',
    data: data
  })
}

// 修改用户转账记录
export function updateUserTransferRecord(data) {
  return request({
    url: '/biz/admin/user/transfer/edit',
    method: 'post',
    data: data
  })
}

// 删除用户转账记录
export function delUserTransferRecord(data) {
  return request({
    url: '/biz/admin/user/transfer/delete',
    method: 'post',
    data: data
  })
}
